import { z } from 'zod';
import {
  notificationSchema,
  paginatedSchema,
  type NotificationDto,
  type Paginated,
} from '@eombor/contracts';
import { apiClient } from '../../auth/model/auth.store.js';
import type { ApiClient } from '../../../shared/api/client.js';

/**
 * Ilova ichi bildirishnomalari. Manba:
 *   `notification/infrastructure/http/notification.controller.ts`
 *
 * `title` va `body` TAYYOR o'zbekcha matn bo'lib keladi — frontend holat
 * yorliqlarini ikkinchi marta tarjima qilmaydi.
 */

const notificationPageSchema = paginatedSchema(notificationSchema);
const readAllSchema = z.object({ updated: z.number().int().nonnegative() });

export interface NotificationQuery {
  onlyUnread?: boolean;
  /**
   * Bitta turdagi xabarlar — bo'lim yonidagi son uchun.
   *
   * Turlar ro'yxati shartnomada YO'Q va bu ataylab: yangi tur qo'shilganda
   * frontendni qayta yig'ish shart bo'lmaydi.
   */
  kind?: string;
  page?: number;
  limit?: number;
}

export interface NotificationApi {
  list: (query?: NotificationQuery) => Promise<Paginated<NotificationDto>>;
  markRead: (id: string) => Promise<NotificationDto>;
  markAllRead: () => Promise<{ updated: number }>;
  /** Hujjat ochilganda uning xabarlari o'qilgan bo'ladi. */
  markEntityRead: (entityType: string, entityId: string) => Promise<{ updated: number }>;
}

const queryString = (query: NotificationQuery): string => {
  const params = new URLSearchParams({
    page: String(query.page ?? 1),
    limit: String(query.limit ?? 20),
  });
  // Sxemada `'true' | 'false'` SATR — boshqa qiymat "hammasi" degani.
  if (query.onlyUnread === true) params.set('onlyUnread', 'true');
  if (query.kind !== undefined) params.set('kind', query.kind);
  return params.toString();
};

export const createNotificationApi = (client: ApiClient): NotificationApi => ({
  list: (query = {}) =>
    client.apiFetch(`/notifications?${queryString(query)}`, { schema: notificationPageSchema }),

  markRead: (id) =>
    client.apiFetch(`/notifications/${encodeURIComponent(id)}/read`, {
      method: 'PATCH',
      schema: notificationSchema,
    }),

  markAllRead: () =>
    client.apiFetch('/notifications/read-all', { method: 'POST', schema: readAllSchema }),

  markEntityRead: (entityType, entityId) =>
    client.apiFetch('/notifications/read-entity', {
      method: 'POST',
      body: JSON.stringify({ entityType, entityId }),
      schema: readAllSchema,
    }),
});

export const notificationApi = createNotificationApi(apiClient);
